<template>
  <section class="space-y-6 text-center">
    <!-- Intro Section: Title + One-line purpose -->
    <div class="space-y-2">
      <h1 class="text-2xl font-semibold dark:text-gray-100">
        {{ t("pages.fitrana.hero.title") }}
      </h1>
      <p class="text-base text-gray-600 dark:text-gray-300 leading-relaxed">
        {{ t("pages.fitrana.hero.subtitle") }}
      </p>
    </div>

    <!-- Per-person Amount: First actionable info -->
    <div class="space-y-2">
      <p class="text-sm text-gray-500 dark:text-gray-400">
        {{ t("pages.fitrana.amount.perPersonLabel") }}
      </p>
      <p class="text-3xl font-bold dark:text-gray-100">
        {{ t("pages.fitrana.amount.currency") }} {{ amount }}
      </p>
    </div>

    <!-- Clarification for this year's amount -->
    <p class="text-xs text-gray-500 dark:text-gray-400">
      {{ t("pages.fitrana.hero.note") }}
    </p>
  </section>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";

defineProps<{
  amount: number;
}>();

const { t } = useI18n();
</script>
